import axiosClient from "../api/axiosClient";
import { IMEI, DEVICE_TYPE, FIREBASE_TOKEN, DEVICE_LANGUAGE } from "../utils/constants";

// Stable browser device ID — persists across sessions
const getDeviceId = () => {
  const KEY = "ps_device_id";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const login = (email, password, rememberMe = true) => {
  const deviceId = getDeviceId();
  const trusted = JSON.parse(localStorage.getItem("ps_trusted_devices") || "[]");
  return axiosClient.post("/Account/Login", {
    email,
    password,
    rememberMe,
    imei: IMEI,
    DeviceType: DEVICE_TYPE,
    FirebaseToken: FIREBASE_TOKEN,
    DeviceLanguage: DEVICE_LANGUAGE,
    DeviceId: deviceId,
    IsTrustedDevice: trusted.length > 0,
  });
};

export const verifyWebLoginOtp = (userId, otp, trustDevice = false) => {
  return axiosClient.post("/PromoterPanel/VerifyWebLoginOtp", {
    UserId: userId,
    Otp: otp,
    TrustDevice: trustDevice,
    DeviceId: getDeviceId(),
  });
};

export const sendWebLoginEmailOtp = (userId) => {
  return axiosClient.post("/PromoterPanel/SendWebLoginEmailOtp", {
    UserId: userId,
    IsFromWebLogin: true,
  });
};
